import { useState } from "react";
import { Card, Field, Grid, ReadOnlyNote, inputCls, btnPrimary } from "./shared";

const FIELDS = [
  ["ragione_sociale", "Ragione sociale"],
  ["partita_iva", "Partita IVA"],
  ["codice_fiscale", "Codice fiscale (se applicabile)"],
  ["codice_sdi", "Codice SDI"],
  ["pec", "PEC"],
  ["referente_amministrativo", "Referente amministrativo"],
];

export default function AziendaSection({ settings, onSave, saving, readOnly }) {
  const [a, setA] = useState(settings.azienda || {});
  return (
    <div className="space-y-5" data-testid="setsection-azienda">
      <Card title="Dati aziendali e fatturazione"
        desc="Dati amministrativi dell'azienda che usufruisce di Dishenda. Usati per la fatturazione dell'abbonamento."
        testid="az-card">
        <Grid>
          {FIELDS.map(([k, label]) => (
            <Field key={k} label={label}>
              <input value={a[k] || ""} onChange={(e) => setA({ ...a, [k]: e.target.value })}
                className={inputCls} data-testid={`az-${k}`} />
            </Field>
          ))}
        </Grid>
        <Field label="Indirizzo di fatturazione">
          <input value={a.indirizzo_fatturazione || ""}
            onChange={(e) => setA({ ...a, indirizzo_fatturazione: e.target.value })}
            placeholder="Via, numero civico, CAP, Città, Provincia" className={inputCls} data-testid="az-indirizzo_fatturazione" />
        </Field>
      </Card>
      {readOnly ? <ReadOnlyNote /> : (
        <button disabled={saving} onClick={() => onSave({ azienda: a })} className={btnPrimary} data-testid="az-save">
          Salva Azienda
        </button>
      )}
    </div>
  );
}
